var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.postAlert,style:(_vm.style)},[_c('span',{staticClass:"msg"},[_vm._v("Sucesso: "+_vm._s(_vm.message))]),_c('div',{staticClass:"close-btn",on:{"click":_vm.closeAlert}},[_c('span',{staticClass:"fas"},[_vm._v("x")])])])}
var staticRenderFns = []

export { render, staticRenderFns }